import { ExportLayerCard } from '@civilgrid/ui/components';
import type { ReactNode } from 'react';
import HoverCard from '~/components2/HoverCard';
import type { ResolvedExportLayer } from './layerLabels';

type ExportLayersHoverCardProps = {
  layers: ResolvedExportLayer[];
  projectionTitle?: string;
  title: string;
  children: ReactNode;
  /** The trigger is an interactive element, so it must carry a stable test id. */
  triggerTestId: string;
  cardTestId?: string;
};

/** Shows an export's layers on hover of its layer count. */
export default function ExportLayersHoverCard({
  layers: resolved,
  projectionTitle,
  title,
  children,
  triggerTestId,
  cardTestId,
}: ExportLayersHoverCardProps) {
  if (resolved.length === 0) return <>{children}</>;

  return (
    <HoverCard
      unstyled
      side="left"
      trigger={
        <span data-testid={triggerTestId} className="cursor-pointer">
          {children}
        </span>
      }
    >
      <ExportLayerCard data-testid={cardTestId} title={title} layers={resolved} projectionLabel={projectionTitle} />
    </HoverCard>
  );
}
